import React, { FC, ChangeEvent, SetStateAction } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { Box, DialogTitle } from "@material-ui/core";
import { SelectItemInterface } from "../../../interface/SelectItemInterface";
import { MyDialog } from "../../Ui/MyDialog";
import { CustomButton } from "../../Ui/CustomButton";
import { PersonFormMultiple } from "../../Common/PersonFormMultiple";
import { CreateUserInput } from "../../../types/graphql-global-types-onboarding";
import { FileInterfaceLinkcy } from "../../../interface/FileInterface";
import { DocumentsType_documentsType } from "../../../graphql/onboarding/document/types/DocumentsType";

interface LeaderModalProps {
  isShareholder?: boolean;
  isAgree: boolean;
  isAccept: boolean;
  information: CreateUserInput;
  email: string;
  phone: string;
  personId?: number | null;
  isSubmitted?: boolean;
  identitySelect: SelectItemInterface[];
  handleIsAgreeChange(
    personId: number,
  ): (event: ChangeEvent<HTMLInputElement>) => void;
  handleSelect(personId: number): (name: string, value: string) => void;
  handlePhoneChange(personId: number, phone: string): void;
  handleEmailChange(
    personId: number,
  ): (event: ChangeEvent<HTMLInputElement>) => void;
  handleInputChange(
    personId: number,
  ): (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleDateChange(personId: number): (name: string, date: any) => void;
  handleAcceptChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleUpload: (
    type: string,
    files: FileInterfaceLinkcy[],
    docType?: string,
  ) => void;
  handleRemoveFile: (type: string) => void;
  open: boolean;
  handleClose: () => void;
  isAdd: boolean;
  handleNext: () => void;
  isLoading?: boolean;
  setInformation(info: SetStateAction<CreateUserInput>): void;
  documentsType: (DocumentsType_documentsType | null)[];
}

const AddUboModal: FC<LeaderModalProps & WrappedComponentProps> = (props) => {
  const {
    intl,
    information,
    handleSelect,
    handleInputChange,
    handlePhoneChange,
    handleDateChange,
    isAgree,
    isAccept,
    handleAcceptChange,
    isSubmitted,
    identitySelect,
    handleUpload,
    handleRemoveFile,
    personId,
    email,
    phone,
    handleEmailChange,
    handleClose,
    open,
    isAdd,
    handleNext,
    isLoading,
    setInformation,
    documentsType,
  } = props;

  return (
    <MyDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      dialogTitle={
        <DialogTitle>
          {intl.formatMessage({ id: "shareholder.dialog.title" })}
        </DialogTitle>
      }
    >
      <Box>
        <PersonFormMultiple
          information={information}
          personId={personId}
          isSubmitted={isSubmitted}
          email={email}
          phone={phone}
          handleInputChange={handleInputChange}
          handleSelect={handleSelect}
          handleDateChange={handleDateChange}
          handleEmailChange={handleEmailChange}
          handlePhoneChange={handlePhoneChange}
          isAgree={isAgree}
          handleIsAgreeChange={handleInputChange}
          isAccept={isAccept}
          handleAcceptChange={handleAcceptChange}
          identitySelect={identitySelect}
          handleUpload={handleUpload}
          handleRemoveFile={handleRemoveFile}
          setInformation={setInformation}
          documentsType={documentsType}
        />
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 5,
          }}
        >
          <CustomButton
            type="button"
            variant="outline4"
            onClick={handleClose}
            label="button.previous"
            disabled={isLoading}
            fullWidthMobile
          />
          <CustomButton
            type="button"
            variant="primary"
            onClick={handleNext}
            label={isAdd ? "save" : "button.next"}
            loading={isLoading}
            fullWidthMobile
          />
        </Box>
      </Box>
    </MyDialog>
  );
};

export default injectIntl(AddUboModal);
